export function sliceToEven(stream, maxLength) {
    if (maxLength === void 0) { maxLength = 6; }
    return sliceToDivisible(stream, 2, maxLength);
}
export function sliceToDivisible(stream, divideBy, maxLength) {
    if (stream.length < divideBy) {
        return stream;
    }
    var length = Math.floor(Math.min(maxLength, stream.length) / divideBy) * divideBy;
    return stream.slice(0, length);
}
//# sourceMappingURL=helpers.js.map